module.exports = __webpack_public_path__ + "static/media/text-convo.d43c8141.png";